import React, {
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { notification } from 'antd';

import RemoteAccessTotalsV2Context from '@totem/components/services/remoteAccess/v2/totals/RemoteAccessTotalsV2Context';
import { QRUserRolesTotals } from '@totem/components/services/remoteAccess/v2/totals/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AUTH0_USERS_ROLES_TOTALS_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const RemoteAccessTotalsV2Container = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const organizationId = userProfile.organization?.id;
  const [loading, setLoading] = useState<boolean>(true);
  const [totals, setTotals] = useState<QRUserRolesTotals | null>(null);
  const [refreshData, setRefreshData] = useState<boolean>(true);

  useEffect(() => {
    setRefreshData(true);
  }, [organizationId]);

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setRefreshData(false);

    setLoading(true);

    fetch(AUTH0_USERS_ROLES_TOTALS_ENDPOINT, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
    })
      .then((res) => res.json())
      .then((result: QRUserRolesTotals) => {
        setTotals(result ?? null);
      })
      .catch(() => {
        notification.error({
          message: 'Failed to load remote access user totals.',
        });
      })
      .finally(() => setLoading(false));
  }, [refreshData, getApiToken]);

  const onRefresh = useCallback(() => {
    setRefreshData(true);
  }, []);

  return (
    <RemoteAccessTotalsV2Context.Provider
      value={{ loading, totals, onRefresh }}
    >
      {children}
    </RemoteAccessTotalsV2Context.Provider>
  );
};

export default RemoteAccessTotalsV2Container;
